import React, { Component } from "react";

import '../../style/category.css';
import '../../style/generic.css';
import {  Link, useParams } from "react-router";
import * as Constanti from '../../Utils/constants.js';
import axios from "axios";
import MarkdownPreview from '@uiw/react-markdown-preview';
import moment from "moment";
import calendar from '../../images/solar_calendar-outline.png';
import timer from '../../images/proicons_timer.png';
import pin from '../../images/teenyicons_pin-outline.png';
import ios from '../../images/ios.png';
import playStore from '../../images/play.png';
import { GoogleMap, Marker, InfoWindow, LoadScript } from "@react-google-maps/api";

class EventsDetail extends Component{
  
  constructor(props){
 
    super(props);
   
    this.state = {
      evento: {},
      imageUrl:"",
      centro: null,
      infoOpen: false,
    }
  }

handleError = () => {
        this.setState({
            imageUrl: Constanti.url_img_new + this.props.thumbnail
        });
    }

  componentDidMount() {
    this.fetchVideo(this.props.params.id,1);
  }


  fetchVideo(id) {
    const api = Constanti.url_Backend + "eventoDetail";
    axios.post(api, { idEvento: id})
      .then(res => {
        const pers = res.data.data;
        const lat = Number(pers.lat);
        const lng = Number(pers.lon);
         this.setState(prev => ({
          evento: pers, 
          imageUrl: Constanti.url_img_new + pers.thumbnail,
          centro:  !isNaN(lat) && !isNaN(lng) ? [lat, lng] :null
          }));
      })
      .catch(err => console.error(err));
  }

  render(){
       const mapContainerStyle = {
width: "100%",
height: "400px"
}; 
    const {evento,imageUrl,centro,infoOpen } = this.state;
    const hasCenter = centro != null && !isNaN(centro[0]) && !isNaN(centro[1]);
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY
    const isFuture = evento.startDate instanceof Date && !isNaN(evento.startDate) && evento.startDate > new Date();
    return (
    <>
  <section className="contentShareWhite padding-top-100">
  <div className="containerShare">
  <div className="left">
    <div className="titleNews margin-bottom-16"> {evento.title}</div>
    <div className="flex horizontal boxData align-center padding-bottom-24">
     <img src={calendar} width={20} height={20} alt="" className="icoShare"/>
     <div className="dataNews icoShare"> {moment(evento.start_date).format('DD/MM/YYYY')}</div>
     <div className="dataNews icoShare"> - </div>
        <img src={pin} width={20} height={20} alt="" className="icoShare"/>
     <div className="dataNews icoShare"> {evento.location} {evento.luogo ? "("+evento.luogo+")":""} </div>
    </div>
 </div>
   <div className="imgShare"> <img  onError={this.handleError} src={imageUrl} alt="img" className="imgShare"></img></div>
   <div className="descriptionShare left padding-top-40 ">  <MarkdownPreview source={evento.body}/></div>
 
   {hasCenter &&
   <> 
   <div className="containerApp flex vertical align-start padding-top-64 padding-bottom-16">
   <hr className="divider margin-bottom-64"></hr>
    <div className="titleMaps">Ubicazione</div>
     {evento.luogo &&<div className="luogoMaps">{evento.luogo}</div>}
     {evento.location && <div className="locationMaps">{evento.location}</div>}
   </div>
    <LoadScript googleMapsApiKey={apiKey}>
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        center={{ lat: centro[0], lng: centro[1] }}
        zoom={13}
      >
      <Marker position={{lat: centro[0], lng: centro[1]}} />
      </GoogleMap>
    </LoadScript>
   </>   
  }
 {isFuture &&
 <div className="containerApp padding-top-80 padding-bottom-80">
  <Link to={evento.link_partecipazione} className="btnEvent">
    Partecipa all’evento
    </Link>
 </div>
  }  
    {hasCenter &&
     <hr className="divider margin-bottom-64"></hr>
    }
   <div className="containerApp padding-top-80 padding-bottom-80">
   <div className="flex vertical justify-center align-center">
    <div className="padding-bottom-24 two-lines">
      Resta aggiornato su tutte le news sull'app ufficiale di Alis
    </div>
    <div className="flex horizontal justify-center gap-8 shareMobile">
    <a href="https://esempio.com" target="_blank" title="app store"><img src={ios} width={169} height={50} alt="app store"/></a>
    <a href="https://esempio.com" target="_blank" title="play store"><img src={playStore} width={169} height={50}  alt="app store"/></a>
    </div>
    </div>
   </div>
  
   </div>
  </section>
  
</>
    )
}
}

export default (props) => (
  <EventsDetail
      {...props}
      params={useParams()}
  />);